import GridContainer from '@rsa-digital/evo-shared-components/components/GridContainer';
import React from 'react';
import { StyledFooter } from './styles';
import useFooterData from '../useFooterData';

const PLExitFooter: React.FC<{ locale: string }> = ({ locale }) => {
  const { footer_compliance, footer_nav_bar } = useFooterData(locale);

  return (
    <GridContainer>
      <StyledFooter
        data-cy="PLExitFooter"
        footerCompliance={footer_compliance}
        footerNavBar={footer_nav_bar}
      />
    </GridContainer>
  );
};

export default PLExitFooter;
